module.exports = __webpack_public_path__ + "img/dapp_sl_bg.8c606213.png";